export default __webpack_public_path__ + "static/media/slotend.cb6a0c6d.mp3";